import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faTimes, faPhone, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import api from "../../../utils/axiosPublic";

const ContactModal = (props) => {
  const form = useRef();
  const navigate = useNavigate();

  const { productSlug } = useParams();

  const [error, setError] = useState({
    phone: "",
    message: "",
    fullName: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const sendEmail = async (e) => {

    if(form.current.user_name.value.toString().length === 0) {
      setError({ ...error, fullName: "Vui lòng nhập tên của bạn" });
      return;
    }


    if (form.current.phone.value.toString().length < 10) {
      setError({ ...error, phone: "Vui lòng nhập số điện thoại từ 10 chữ số" });
      return;
    }

    const success = await handleSaveCustomer();

    if (success) {
      navigate("/dang-ky-thanh-cong");
      toast(`Đăng ký thành công`, {
        type: "success",
        autoClose: 1000,
        style: { marginTop: "50px" },
      });
      formClose();
    }
  };

  const handleSaveCustomer = async () => {
    const fullName = form.current.user_name.value.toString();
    const phone = form.current.phone.value.toString();
    const message = form.current.message.value.toString();

    const data = {
      fullName: fullName,
      phone: phone,
      message: message,
      slug: productSlug,
    };

    try {
      setIsLoading(true);
      const res = await api.post(`/customer/create`, data);
      if (res.data.errCode === 0) {
        return true;
      }

    } catch (error) {
      setError(error.response?.data?.messages);
    } finally {
      setIsLoading(false);
    }

    return false;
  };

  const formClose = () => {
    const { onHide } = { ...props };
    setError({
      phone: "",
      message: "",
      fullName: "",
    });
    return onHide();
  };

  return (
    <Modal
      show={props.show}
      onHide={formClose}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="fw-bold">
        <FontAwesomeIcon icon={faPhone} />&nbsp;
        Liên hệ với chúng tôi
      </Modal.Header>
      <Modal.Body className="p-4 ">
        <Form ref={form} onSubmit={() => sendEmail()}>
          <Row>
            <Col xs={12}>
              <Alert variant="primary">
                <FontAwesomeIcon className="text-primary me-1" icon={faInfoCircle} />
                Hãy để lại thông tin. Tư vấn viên Kafood sẽ liên hệ với bạn trong thời gian
                sớm nhất!
              </Alert>
            </Col>
            <Col>
              <Form.Floating className="mb-3">
                <Form.Control
                  className="form-contact"
                  type="text"
                  name="user_name"
                  placeholder="Tên của bạn"
                  isInvalid={error?.fullName}
                  onChange={(e) => setError({ ...error, fullName: "" })}
                />
                <Form.Label>
                  Tên của bạn
                </Form.Label>
                <i className="text-danger">{error?.fullName}</i>
              </Form.Floating>
            </Col>
            <Col>
              <Form.Floating className="mb-3">
                <Form.Control
                  className="form-contact"
                  type="text"
                  name="phone"
                  placeholder="Số điện thoại"
                  isInvalid={error?.phone}
                  onChange={(e) => setError({ ...error, phone: "" })}
                  required
                />
                <Form.Label>
                  Số điện thoại<i className="text-danger">*</i>
                </Form.Label>
                <i className="text-danger">{error?.phone}</i>
              </Form.Floating>
            </Col>
          </Row>

          <Form.Floating >
            <Form.Control 
              className="form-contact" 
              as="textarea" 
              type="text" 
              placeholder="Lời nhắn" 
              name="message" 
              isInvalid={error?.message} 
              onChange={(e) => setError({ ...error, message: "" })} 
            />
            <Form.Label>Lời nhắn </Form.Label>
            <i className="text-danger">{error?.message}</i>
          </Form.Floating>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => formClose()}>
          <FontAwesomeIcon icon={faTimes} /> Đóng
        </Button>
        <Button type="submit" variant="success" disabled={isLoading} onClick={() => sendEmail()}>
          {isLoading ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faPaperPlane} />} Gửi
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContactModal;
